var EquipmentTypeLegacyModule = /** @class */ (function () {
    function EquipmentTypeLegacyModule() {
    }
    return EquipmentTypeLegacyModule;
}());
export { EquipmentTypeLegacyModule };
